import { createTheme, Theme, ThemeOptions } from "@mui/material/styles";

// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// const fontFamily = isSafari ? "sans-serif" : "Inter, sans-serif";

// Lazy font family calculation for Safari
const getFontFamily = () => {
  if (typeof navigator !== "undefined") {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      ? "sans-serif"
      : "Inter, sans-serif";
  }
  return "Inter, sans-serif"; // Default font family for server-side rendering
};
export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#0097ab",
      light: "rgba(0, 151, 171, 0.1)",
    },
    secondary: {
      main: "#f50057",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 768,
      lg: 976,
      xl: 1190,
    },
  },
  typography: {
    fontFamily: getFontFamily(),
    h1: {
      fontSize: "40px",
      fontWeight: 600,
    },
    h2: {
      fontSize: "35px",
      fontWeight: 600,
    },
    h3: {
      fontSize: "30px",
      fontWeight: 600,
    },
    h4: {
      fontSize: "25px",
      fontWeight: 600,
    },
    h5: {
      fontSize: "20px",
      fontWeight: 600,
    },
    h6: {
      fontSize: "15px",
      fontWeight: 500,
    },
  },
  components: {
    MuiPopper: { defaultProps: { disablePortal: true } },
    MuiButton: {
      styleOverrides: {
        root: (props: { theme: Theme }) => ({
          boxShadow: "none",
          borderRadius: 8,
          height: "50px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "15px",
          lineHeight: "normal",
          [`@media (min-width: ${props.theme.breakpoints.values.md}px)`]: {
            fontSize: "16px",
          },
        }),
        containedPrimary: {
          color: "#fff",
          "&:hover": {
            backgroundColor: "#000",
            color: "#fff",
          },
        },
        outlinedPrimary: {
          borderRadius: 8,
          color: "#0097ab",
          backgroundColor: "transparent",
        },
        textPrimary: {
          borderRadius: 8,
          color: "#0097ab",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: "100%",
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            height: "50px",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#bcbfc1",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000",
              borderWidth: "1px",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0 0px 5px rgba(0, 0, 0, 0.175)",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "transparent",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "transparent !important",
          padding: "14px",
          "&:last-child": {
            borderBottom: "none",
          },
          "&:hover": {
            backgroundColor: "transparent",
            color: "#0097ab",
          },
          "&.Mui-focused": {
            backgroundColor: "transparent",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            outline: "none",
          },
        },
      },
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          fontSize: "14px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#000",
          color: "#fff",
          fontSize: "12px",
          borderRadius: "4px",
        },
        arrow: {
          color: "#000",
        },
      },
    },
  },
};

export const theme = createTheme(themeOptions);
